import { getCompanyInfo } from '@/api/detection';

const state = {
  companyInfo: {
    logo: '',
    techSupport: '',
    phone: '',
    supervisionPhone: '',
    copyright: '',
    title: ''
  },
  isLoaded: false
};

const mutations = {
  SET_COMPANY_INFO(state, data) {
    state.companyInfo = { ...state.companyInfo, ...data };
    state.isLoaded = true;
  }
};

const actions = {
  async fetchCompanyInfo({ commit, state }) {
    // 如果已经加载过，就不再重复请求
    if (state.isLoaded) {
      return state.companyInfo;
    }
    
    try {
      const response = await getCompanyInfo();
      if (response) {
        commit('SET_COMPANY_INFO', response);
        return response;
      }
    } catch (error) {
      console.error('获取公司信息失败:', error);
      // 设置默认值
      commit('SET_COMPANY_INFO', {
        techSupport: '18710143876',
        logo: '',
        phone: '',
        supervisionPhone: '',
        copyright: '',
        title: '报名系统'
      });
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/company.js